export const GET_APP_EXPORT_URL = 'GET_APP_EXPORT_URL'   //获取app的下载地址
export const GET_APP_AGREEMENT = 'GET_APP_AGREEMENT'   //获取订单协议

//活动模块
export const GET_DO_CARD_DATA = 'GET_DO_CARD_DATA'  //获取首页公共数据
export const GET_DO_CARD_MY_DATA = 'GET_DO_CARD_MY_DATA'  //获取首页我的数据（勋章模块）
export const SAVE_PRIZE_TYPE = 'SAVE_PRIZE_TYPE'  //打卡成功之后保存当天的奖品类型信息
export const GET_SHARE_POSTER = 'GET_SHARE_POSTER'  //获取分享页底图
export const CHANGE_RECEIVE_STATUS = 'CHANGE_RECEIVE_STATUS'  //保存领奖信息成功
export const CHANGE_CLOCK_STATUS = 'CHANGE_CLOCK_STATUS'  //改变打卡状态
export const GET_AWARD_TIPS = 'GET_AWARD_TIPS'  //获取领取奖品的提示语

export const GET_CUSTOM_EXPORT_URL = 'GET_CUSTOM_EXPORT_URL' //获取安卓定制版app下载路径
 


// WEBPACK FOOTER //
// ./src/store/mutation.js